export const cars = [
  {
    id: 1,
    name: "BMW 5 Series Competition",
    year: 2024,
    price: 180,
    image: "/images/car_1.png",
    tag: "Luxury",
    transmission: "Auto",
    seats: 5,
    type: "Petrol",
    category: "Luxury",
    rating: 4.9,
    reviews: 124,
    engine: "4.4L V8",
    power: "617 HP",
    acceleration: "3.2s",
    about: "The BMW 5 Series Competition represents the perfect harmony between high-performance sports car dynamics and luxury sedan comfort. With its precisely tuned suspension and powerful V8 engine, it delivers an unparalleled driving experience for those who refuse to compromise.",
    features: ["Adaptive Cruise Control", "Leather Interior", "Harman Kardon Sound", "Parking Assistant Plus", "Sunroof", "Head-up Display"],
    rentalTerms: ["Driver must be 25+", "Valid License Required", "No smoking inside", "Pets allowed in carriers", "Return with full tank"],
    host: { name: "Sarah J.", rating: 4.9, image: "https://i.pravatar.cc/150?u=sarah" }
  },
  {
    id: 2,
    name: "Range Rover Sport",
    year: 2023,
    price: 220,
    image: "/images/car_2.png",
    tag: "SUV",
    transmission: "Auto",
    seats: 5,
    type: "Hybrid",
    category: "SUV",
    rating: 4.8,
    reviews: 89,
    engine: "3.0L i6",
    power: "395 HP",
    acceleration: "5.7s",
    about: "Dominate every terrain with the Range Rover Sport. This luxury SUV combines legendary off-road capability with a refined interior and advanced hybrid technology, making it the ideal choice for family adventures or city exploration.",
    features: ["Air Suspension", "Terrain Response 2", "Meridian Sound", "Panoramic Roof", "3D Surround Camera", "Heated Seats"],
    rentalTerms: ["Off-road use prohibited", "Valid License Required", "No smoking inside", "Professional detailing fee if returned dirty", "Standard Insurance Included"],
    host: { name: "Michael R.", rating: 4.7, image: "https://i.pravatar.cc/150?u=michael" }
  },
  {
    id: 3,
    name: "Tesla Model S Plaid",
    year: 2024,
    price: 210,
    image: "/images/car_1.png",
    tag: "Electric",
    transmission: "Auto",
    seats: 5,
    type: "EV",
    range: "637 km",
    category: "Electric",
    rating: 4.9,
    reviews: 156,
    engine: "Tri-Motor",
    power: "1,020 HP",
    acceleration: "1.99s",
    about: "Step into the future with the Tesla Model S Plaid. Experience world-leading acceleration and cutting-edge technology. The Plaid platform allows for sustained high-speed driving while maintaining the highest safety standards in its class.",
    features: ["Autopilot", "Full Self-Driving Capability", "Gaming Computer", "Carbon Fiber Decor", "Yoke Steering", "Supercharging Access"],
    rentalTerms: ["Supercharger fees apply", "Return with 20%+ charge", "No smoking inside", "Strict late return policy", "Tech support included"],
    host: { name: "Elon M.", rating: 5.0, image: "https://i.pravatar.cc/150?u=elon" }
  },
  {
    id: 4,
    name: "Mercedes-Benz S-Class",
    year: 2024,
    price: 250,
    image: "/images/car_1.png",
    tag: "Luxury",
    transmission: "Auto",
    seats: 5,
    type: "Petrol",
    category: "Luxury",
    rating: 5.0,
    reviews: 72,
    engine: "3.0L i6 Turbo",
    power: "429 HP",
    acceleration: "4.8s",
    about: "The S-Class is the flagship of Mercedes-Benz, offering a level of sophistication and innovation that sets the benchmark for the entire industry. Experience rear-seat luxury and front-seat command like never before.",
    features: ["MBUX Infotainment", "Burmester Surround Sound", "Energizing Comfort", "Magic Body Control", "Soft Close Doors", "Ambient Lighting"],
    rentalTerms: ["Valet service available", "Concierge support 24/7", "No smoking inside", "Premium Fuel Only", "Insurance Included"],
    host: { name: "Daimler K.", rating: 4.9, image: "https://i.pravatar.cc/150?u=daimler" }
  },
  {
    id: 5,
    name: "Porsche 911 Carrera",
    year: 2024,
    price: 300,
    image: "/images/car_2.png",
    tag: "Luxury",
    transmission: "Auto",
    seats: 2,
    type: "Petrol",
    category: "Luxury",
    rating: 5.0,
    reviews: 45,
    engine: "3.0L Flat-6",
    power: "379 HP",
    acceleration: "4.0s",
    about: "Driven by performance. The Porsche 911 Carrera is timeless. For decades, it has set the standard for sports cars. Its rear-engine layout provides a unique driving feel that true enthusiasts will instantly appreciate.",
    features: ["PASM Sport Suspension", "Sport Chrono Package", "Bose Surround Sound", "Sport Exhaust System", "LED Matrix Headlights", "Comfort Access"],
    rentalTerms: ["Strict mileage limit", "Track use strictly prohibited", "No smoking inside", "Premium Fuel Only", "Security Deposit Required"],
    host: { name: "Ferry P.", rating: 5.0, image: "https://i.pravatar.cc/150?u=ferry" }
  },
  {
    id: 6,
    name: "Audi Q8 E-tron",
    year: 2024,
    price: 195,
    image: "/images/car_1.png",
    tag: "SUV",
    transmission: "Auto",
    seats: 5,
    type: "EV",
    range: "582 km",
    category: "SUV",
    rating: 4.7,
    reviews: 64,
    engine: "Dual Motor",
    power: "402 HP",
    acceleration: "5.4s",
    about: "The Audi Q8 e-tron is a masterpiece of electric mobility. Combining the spaciousness of a flagship SUV with the silent, efficient power of a modern electric drivetrain, it's the ultimate vehicle for sustainable luxury travel.",
    features: ["Quattro AWD", "Virtual Cockpit", "Bang & Olufsen Sound", "Matrix LED Headlights", "Adaptive Air Suspension", "Top View Camera"],
    rentalTerms: ["Charging cable included", "Return with 20%+ charge", "No smoking inside", "E-ZPass Included", "24/7 Roadside Assistance"],
    host: { name: "Vorsprung D.", rating: 4.8, image: "https://i.pravatar.cc/150?u=vorsprung" }
  }
];
